module.exports = __webpack_public_path__ + "img/woman-working.f771f4b6.png";